export default __webpack_public_path__ + "static/media/user-list.d451603c.svg";